import { EmployeeService } from 'app/modules/employee/services/employee.service';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {UntypedFormBuilder, UntypedFormGroup, FormArray, Validators} from '@angular/forms';
import {CostReportService} from '../../../services/cost-report.service';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { ReportsCommonService } from 'app/modules/reports/services/reports-common.service';
import { MatSelectChange } from "@angular/material/select";
@Component({
    selector: 'app-cost-report-popup',
    templateUrl: './cost-report-popup.component.html',
    styleUrls: ['./cost-report-popup.component.scss'],
    standalone: false
})
export class CostReportPopupComponent implements OnInit {
  costReportForm: UntypedFormGroup;
  enfermedadIsChecked:boolean =true;
  accidenteIsChecked:boolean=false;
  costeDelTrabajador:boolean;
  defaultReportType: string;
  datePeridIsShow:boolean=true;
  defaultCheckBox:boolean=true;
  conveniosDataSource:any;
  empresaDetails: any;
  empresaId:number;
  selectedData: { value: string; text: string } ;
  constructor(
    private dialogRef: MatDialogRef<CostReportPopupComponent>,
    private formBuilder: UntypedFormBuilder,
    private costReportService : CostReportService,
    private fileExportService: FileExportService,
    private pageLoaderService : PageLoaderService,
    private sharedService : SharedService,
    public employeeService: EmployeeService,
    public reportsCommonService: ReportsCommonService,
    
  ) { 
    this.defaultReportType = 'Excel';
    this.defaultCheckBox=true;
  }

  ngOnInit(): void {
    // set empressa ID
    this.reportsCommonService.empresaId = JSON.parse(localStorage.getItem('Empresa'));
    // set employee id 
    this.reportsCommonService.trabajadorId = JSON.parse(localStorage.getItem('EmplooyeeID'));

    this.formInitialization();
    this.clearValidation();
    this.loadConveniosDropdown(); 
  }

  clearValidation()
  {
    this.costReportForm.get('Convenio').setValidators(Validators.required);
    this.costReportForm.get('ContProfesionales').setValidators(Validators.required);

    this.costReportForm.get('DateFrom').setValidators(Validators.required);
    this.costReportForm.get('DateTo').setValidators(Validators.required);

    this.costReportForm.get('ContProfesionales').clearValidators();
    this.costReportForm.controls["ContProfesionales"].updateValueAndValidity();
  }

  formInitialization()
  {
    this.costReportForm =this.formBuilder.group({
      DefaultReport :['',Validators.required],
      Enfermedad:[''],
      AccidenteLaboral:[false],
      PermisoRetribuido:[false],
      DateFrom:['',Validators.required],
      DateTo:['',Validators.required],
      Convenio:[''],
      ContProfesionales:[''],
      SalarioBruto:['',Validators.required],
      TrabajadorId:[this.reportsCommonService.trabajadorId],
      EmpresaID:[this.reportsCommonService.empresaId],
      ConvenioName:[''],
    })
  }
  
  public close(): void {
    this.dialogRef.close();
  }

  selectedValue(event: MatSelectChange) {
    this.selectedData = {
      value: event.value,
      text: event.source.triggerValue
    };
    this.costReportForm.patchValue({
      ConvenioName:this.selectedData.text
    })
  }

  enfermedadClick(value:any)
  {
    //show, hide convenio dropdown
    this.enfermedadIsChecked=value.checked;
    if(!value.checked)
    {
      this.costReportForm.get('Convenio').clearValidators();
      this.costReportForm.controls["Convenio"].updateValueAndValidity();
    }else
    {
      this.costReportForm.get('Convenio').setValidators(Validators.required);
      this.costReportForm.controls["Convenio"].updateValueAndValidity();
    }
  }

  accidenteClick(value:any)
  {
    if(!value.checked)
    {
      this.costReportForm.get('ContProfesionales').clearValidators();
      this.costReportForm.controls["ContProfesionales"].updateValueAndValidity();
    }else
    {
      this.costReportForm.get('ContProfesionales').setValidators(Validators.required);
      this.costReportForm.controls["ContProfesionales"].updateValueAndValidity();
    }
    //show, hide contingencias input
    this.accidenteIsChecked=value.checked;
  }

  reportTypeClick(value:any)
  {
    this.datePeridIsShow = this.defaultReportType=='Excel'? true : false;
    if(this.defaultReportType!='Excel')
    {
      this.costReportForm.get('DateFrom').clearValidators();
      this.costReportForm.controls["DateFrom"].updateValueAndValidity();

      this.costReportForm.get('DateTo').clearValidators();
      this.costReportForm.controls["DateTo"].updateValueAndValidity();
    }
  }
 
  loadConveniosDropdown()
  {
    this.costReportService.GetConvenioList(this.reportsCommonService.trabajadorId).subscribe(res=>{
      this.conveniosDataSource=res.result;
    })
  }

  onSubmit()
  {
    this.costReportForm.markAllAsTouched();
    this.costReportForm.updateValueAndValidity();

    if(this.costReportForm.valid)
    {
      this.pageLoaderService.ShowPageLoader();
      this.costReportService.GetCostReport(this.costReportForm.value).subscribe(res => {
        if (res.result) { 
          if(res.result==1)//No records found
          {
            this.pageLoaderService.HidePageLoader();
            this.sharedService.ShowSnackBar('No hay bajas en el periodo especificado');
          }
          else
          {
            this.fileExportService.DownloadFile(res.result.file, res.result.fileName);
            this.pageLoaderService.HidePageLoader();
            return res;
          }
        }
        else{
              this.sharedService.ShowSnackBar('Generación de informe fallido');
              this.pageLoaderService.HidePageLoader();
        }
        }, error => {
          this.pageLoaderService.HidePageLoader();
          console.error(error);
          this.sharedService.ShowSnackBar('Generación de informe fallido');
        });  
        this.close();       
    }
    else
    {
        this.sharedService.ShowSnackBar('Se deben completar todos los parámetros');
    }
      
  }
}
